export default __webpack_public_path__ + "maps-examples-show-hide-layer-thumbnail-960-8c3e033b61e3511f481afeb000b2530e.webp";